import * as React from "react";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { TradeTable, type TradeRow } from "../TradeTable";
import { useTradeBook } from "@/hooks/queries/useTradeBook";

interface ExecutionOrderPayload {
  execution_id: string;
  instrument_token: string;
  side: string;
  quantity: number;
  status: string;
}

export function TradesTableSection(): React.JSX.Element {
  const tradeBookQuery = useTradeBook();

  return (
    <StatusCard title="Trades Table">
      <QueryStateBoundary
        query={tradeBookQuery}
        isEmpty={(data) => (data as unknown as ExecutionOrderPayload[]).length === 0}
        emptyMessage="No trades reported by the backend."
      >
        {(payload) => {
          const rows: TradeRow[] = (payload as unknown as ExecutionOrderPayload[]).map((t) => ({
            execution_id: t.execution_id,
            instrument_token: t.instrument_token,
            side: t.side,
            quantity: t.quantity,
            status: t.status,
          }));
          return <TradeTable trades={rows} />;
        }}
      </QueryStateBoundary>
    </StatusCard>
  );
}
